import {
    Component,
    Input,
    ComponentFactoryResolver,
    ViewChild,
    OnInit, Injector, Compiler, ViewContainerRef
} from "@angular/core";
import {ContentContainerDirective} from "../../content-container.directive";
import {SkeletonComponent} from "../../skeleton.component";
import {Tab} from "./tab.model";
import {importHelper} from "./importHelper";

@Component({
    selector: "app-tab-content",
    template: "<ng-template content-container></ng-template>"
})
export class TabContentComponent implements OnInit {
    @Input() tab;
    @ViewChild(ContentContainerDirective)
    contentContainer: ContentContainerDirective;
    currentModule: any;
    constructor(private componentFactoryResolver: ComponentFactoryResolver, private inj: Injector, private compiler: Compiler,
        private importHelper: importHelper) {}

    ngOnInit() {
        this.currentModule = this.importHelper.moduleDetails.find(mod => mod.router == this.tab.router);
        console.log("this.currentModule..", this.currentModule);
        import('../lazyloader/'+ this.currentModule.path) 
            .then(m => {
        let mod = m[this.currentModule.module]
        this.compiler.compileModuleAsync(mod)
            .then(factory => {
                const module = factory.create(this.inj);
                const [loadedcomp] = module.injector.get(this.currentModule.provider);
                const componentFactory = module.componentFactoryResolver.resolveComponentFactory(
                    loadedcomp.component)
                const viewContainerRef = this.contentContainer.viewContainerRef;
                const componentRef = viewContainerRef.createComponent(componentFactory);
                (componentRef.instance as SkeletonComponent).data = this.tab.tabData;
            })
    })
}
}



// WEBPACK FOOTER //
// D:/ESealStore_AJS/src/app/components/Multitab/tab-content.component.ts